import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';

@Injectable()
export class IvyRouteReuseStrategy extends IonicRouteStrategy {
  // Do not reuse the chatting route so its component is recreated each time.
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    const path = future?.routeConfig?.path || '';
    if (path === 'chatting') {
      return false;
    }
    return super.shouldReuseRoute(future, curr);
  }
}

